export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/transcode.worker.4ab9b540.worker.js");
}
